import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../../components/ui/Container';
export function ArabicTermsAndConditions() {
  return <section className="py-16 text-right md:py-24" dir="rtl" data-id="element-3752" data-mp="26cb1qpn16fa3">
      <Container data-id="element-3753" data-mp="2l28mswpnyov2">
        <article className="mx-auto max-w-4xl" data-id="element-3754" data-mp="2l2qls13pnh6o">
          <h1 className="font-display text-4xl font-semibold leading-[1.5] text-ink-900 md:text-6xl" data-id="element-3755" data-mp="2g4gptoa5wck0">
            الشروط والأحكام
          </h1>
          <p className="mt-4 text-ink-500" data-id="element-3756" data-mp="1sf4kx0lvaqni">
            <strong data-id="element-3757" data-mp="1nfrobo57257q">آخر تحديث:</strong> 1 فبراير 2026
          </p>

          <div className="mt-10 space-y-8 leading-loose text-ink-700" data-id="element-3758" data-mp="1nhcmdnqpw6ac">
            <p data-id="element-3759" data-mp="22dk3gf6twrle">
              تنظّم هذه الشروط والأحكام («الشروط») وصولك إلى موقع{' '}
              <strong data-id="element-3760" data-mp="1xco0c3uax9h1">المركز الدولي للتعلّم الإسلامي (IILH)</strong> واستخدامك له،
              إضافةً إلى مشاركتك في البرامج والخدمات والأنشطة التي ننظّمها.
            </p>
            <p data-id="element-3761" data-mp="38t4i43tbw272">
              بدخولك إلى هذا الموقع، أو تسجيل حساب، أو استخدام خدماتنا، فإنك توافق
              صراحةً على الالتزام بهذه الشروط.
            </p>
            <p data-id="element-3762" data-mp="2svgibwbvj79f">
              إذا كنت لا توافق على أي جزء من هذه الشروط، فيجب عليك التوقف فورًا عن
              استخدام الموقع.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3763" data-mp="32tcwkx03yibr">
              استخدام الموقع
            </h2>
            <p data-id="element-3764" data-mp="36tdjl619w1uf">
              يُقدَّم المحتوى المتاح على هذا الموقع لأغراض المعلومات والتعليم ودعم
              المجتمع فقط.
            </p>
            <p data-id="element-3765" data-mp="2f3sbo8ke9azu">
              <strong data-id="element-3766" data-mp="2f5d5tx2sqrx6">الاستخدام المشروع:</strong> يوافق المستخدمون على استخدام هذا
              الموقع باحترام وبما يتوافق تمامًا مع جميع القوانين واللوائح المعمول
              بها.
            </p>
            <p data-id="element-3767" data-mp="2nxng1edoyxef">
              <strong data-id="element-3768" data-mp="2ny6ng15pu3e7">الأنشطة المحظورة:</strong> يُحظر منعًا باتًا الاستخدام غير
              المصرّح به للموقع، أو إساءة استخدام محتواه، أو أي سلوك يُعد ضارًا
              بالمنصة أو بمجتمعها. ويشمل ذلك، على سبيل المثال لا الحصر، نشر البرمجيات
              الضارة، أو جمع البيانات آليًا، أو مضايقة المستخدمين الآخرين.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3769" data-mp="2yovrnjoaafmm">
              البرامج والخدمات
            </h2>
            <p data-id="element-3770" data-mp="38fqeap5fzh8l">
              <strong data-id="element-3771" data-mp="38g8fm06yolnd">الأهلية:</strong> قد تخضع المشاركة في برامج أو خدمات تعليمية
              محددة لمعايير أهلية صارمة ولمراجعة طلبك.
            </p>
            <p data-id="element-3772" data-mp="2frukptb665g1">
              <strong data-id="element-3773" data-mp="2ftfbr8y9z695">الحق في التعديل:</strong> يحتفظ المركز الدولي للتعلّم الإسلامي
              بالحق في تعديل أي برنامج أو خدمة أو تعليقها أو إيقافها في أي وقت ودون
              إشعار مسبق.
            </p>
            <p data-id="element-3774" data-mp="2ottz0dusuvfa">
              <strong data-id="element-3775" data-mp="2oudkg4jns1y2">عدم ضمان النتائج:</strong> رغم سعينا للتميّز، لا نقدّم ضمانًا
              لنتائج تعليمية محددة أو نتائج شخصية ناتجة عن خدمات الدعم التي نقدمها.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3776" data-mp="41iightvzoca">
              المدفوعات والشروط المالية
            </h2>
            <p data-id="element-3777" data-mp="7k7ryzqfq5bi">
              <strong data-id="element-3778" data-mp="7jplzbdz0cqe">عام:</strong> تخضع جميع التبرعات ورسوم العضوية وتكاليف البرامج
              للشروط المحددة التي يتم الإفصاح عنها لك عند الدفع.
            </p>
            <p data-id="element-3779" data-mp="3trz36kdqda57">
              <strong data-id="element-3780" data-mp="3tsh2xqzlq6hv">التبرعات:</strong> جميع التبرعات طوعية وغير قابلة للاسترداد
              بشكل صارم.
            </p>
            <p data-id="element-3781" data-mp="2mpjtbk8ru4k">
              <strong data-id="element-3782" data-mp="2m67qbh9vzyg">الاسترداد:</strong> تخضع العضويات والبرامج التعليمية المدفوعة
              تحديدًا إلى{' '}
              <Link to="/ar/legal/refund-policy" className="font-medium text-forest-700 underline underline-offset-2 transition hover:text-forest-800" data-id="element-3783" data-mp="qdboqtyy8yac">
                سياسة الاسترداد
              </Link>
              {' '}الخاصة بنا.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3784" data-mp="liflexo9iohx">
              تحديد المسؤولية
            </h2>
            <p data-id="element-3785" data-mp="1e1uxtbptpf3h">
              إلى أقصى حد يسمح به القانون، لا يتحمل المركز الدولي للتعلّم الإسلامي
              المسؤولية عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية
              تنشأ عن استخدامك لهذا الموقع أو مشاركتك في برامجنا أو ترتبط بذلك.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3786" data-mp="3cj6fx7t31nyh">
              القانون الحاكم
            </h2>
            <p data-id="element-3787" data-mp="37mfzukha2sd2">
              تخضع هذه الشروط وتُفسَّر وفقًا للقوانين السارية في الولاية القضائية
              التي تُسجَّل فيها المنظمة قانونيًا.
            </p>
          </div>
        </article>
      </Container>
    </section>;
}